import React from "react";
import HistoryVariant6 from "./HistoryVariant6";

const HistorySelector = () => {
  return (
    <div className="w-full">
      <HistoryVariant6 />
    </div>
  );
};

export default HistorySelector;
